import React, { useState } from 'react';
import style from '../content-list.module.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from '../../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import { AddImage } from './AddImage';
import { Image } from './Image';
import { Image as TImage } from '../../types';
import { usePermissions } from '../../../../hooks';

type Props = {
	scrollRef:any|null;
	hasMore:boolean;
	contents: (TImage & { id: string; updatedAt: string|null; createdAt: string })[];
	refetchContent: () => void;
	loadMore: () => void;
};

export function ImageList(props: Props) {
	const {scrollRef, contents: images, hasMore, refetchContent, loadMore } = props;

	return (
		<div className={style.contentList}>
			<Header {...props} />
			<div className={style.selector}>
				<div>
					<p>Image</p>
				</div>
				<p>Updated At</p>
				<p>Created At</p>
			</div>
			<div id="infiniteScrollTarget" ref={scrollRef} className={style.textList}  style={{overflow: "auto", height: "calc(100vh - 200px)"}}>
				{images.length>0?
					<InfiniteScroll
						dataLength={images.length}
						next={loadMore}
						hasMore={hasMore}
						scrollableTarget="infiniteScrollTarget"
						loader={<div className={style.loadingContainer}>Loading...</div>}>
						{images.map((el) => (
							<Image key={el.id} image={el} refetchContent={refetchContent} />
						))}
					</InfiniteScroll>
				:
					null
				}
			</div>
		</div>
	);
}

function Header(props: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const canCreate = usePermissions('content.Create')
	return (
		<div className={style.header}>
			{canCreate &&
				<button className={style.add} onClick={() => setIsOpen(true)}>
					<img src={AddIcon} alt="add" />
					<span>Add Image</span>
				</button>
			}
			{isOpen && (
				<AddImage
					isOpen={isOpen}
					close={() => setIsOpen(false)}
					refetchContent={props.refetchContent}
				/>
			)}
		</div>
	);
}
